import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateAgo',
  pure: false
})
export class DateAgoPipe implements PipeTransform {

  transform(value: string, ...args: unknown[]): unknown {
    if (value) {
      const seconds = Math.floor((+new Date() - +new Date(value)) / 1000);
      if (seconds < 29) // less than 30 seconds ago will show as 'Just now'
        return 'Gerade eben';
      const intervals = {
        'Jahr': 31536000,
        'Monat': 2592000,
        'Woche': 604800,
        'Tag': 86400,
        'Stunde': 3600,
        'Minute': 60,
        'Sekunde': 1
      };
      let counter;
      for (const i in intervals) {
        counter = Math.floor(seconds / intervals[i]);
        if (counter > 0)
          if (counter === 1) {
            return 'Vor ' + counter + ' ' + i;
          } else {
            switch(i){
              case "Jahr":
              case "Monat":
              case "Tag":
                return 'Vor ' + counter + ' ' + i + "en";
              default:
                return 'Vor ' + counter + ' ' + i + "n";              
            }
          }
      }
    }
    return value;
  }

}
